import { ApolloLink } from 'apollo-link';
import { store } from 'services/state';
import { setShouldUpdateAction, setCurrentEnvironmentAction } from 'actions/user';

const checkUpdateAfterware = new ApolloLink((operation, forward) => (
  forward(operation).map((response) => {
    const { response: res } = operation.getContext();
    const { currentEnvironment } = store.getState().userStore;
    if (!currentEnvironment) {
      return response;
    }
    const promotedEnvHeader = res.headers && res.headers.get('x-promoted-environment');
    if (promotedEnvHeader !== currentEnvironment) {
      store.dispatch(setShouldUpdateAction(true));
      store.dispatch(setCurrentEnvironmentAction(promotedEnvHeader));
    }
    return response;
  })
));

export default checkUpdateAfterware;
